<template>
  <button
    ref="formButton"
    :class="['spl-button', {'spl-button-secondary': secondary}, {'spl-button-wide': wide}, {'spl-button-extrapadding': extrapadding}, {'spl-button-nomargin': nomargin}]"
    :disabled="disabled"
    @click="clicked"
    @focus="handleFocus">
    <span
      @mousedown="handleMouseDown"
      @mouseup="handleMouseUp">
      <slot />
    </span>
  </button>
</template>

<script>
import { debounce } from 'lodash'
export default {
  name: 'FormButton',
  props: [
    'secondary',
    'wide',
    'nomargin',
    'extrapadding',
    'disabled'
  ],
  data () {
    return {
      mouseDown: false,
      debouncedClick: debounce(this.emitClick, 500, { leading: true, trailing: false })
    }
  },
  methods: {
    clicked () {
      this.debouncedClick()
    },
    emitClick () {
      this.$emit('onClick')
    },
    handleMouseDown () {
      this.mouseDown = true
    },
    handleMouseUp () {
      setTimeout(() => {
        this.mouseDown = false
      }, 100)
    },
    handleFocus (event) {
      if (this.mouseDown) {
        this.$refs.formButton.blur()
      }
    }
  }
}
</script>

<style lang="scss">
    @import '../../variables.scss';

    .spl-button {
        background-color: $middleYellow;
        border: none;
        border-radius: 4px;
        color: $mainInputColor;
        cursor: pointer;
        font-family: $opensans;
        font-size: 13px;
        font-weight: 600;
        height: 40px;
        padding: 5px 20px;
        margin: 0 20px $mainBottomMargin 0;
        transition: all $shortTransition ease-in-out;

        @include mobile() {
            font-size: 16px;
            height: 50px;
        }
        &-nomargin {
            margin-bottom: 0;
        }
        &[disabled] {
            cursor: not-allowed;
            opacity: 0.5;
        }
        &-extrapadding {
            padding: 5px 40px;
        }
        &-wide {
            margin-right: 0;
            width: 100%;
        }
        &-shadow {
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.1);
        }
        &-secondary {
            background-color: rgba($disabledYellow, 0.2);
            color: $disabledYellow;
        }
        &:not([disabled]):hover {
            background-color: #fff;
            color: $yellowButtonLabelHover;
        }
        &:focus {
          background-color: #fff;
          color: $yellowButtonLabelHover;
        }
        &__delete {
          background-color: $red
        }
    }
</style>
